import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../../../context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from '../../../../../../../../../lib/constants/constant';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';

// import schemas
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import Schema from '../../../../../../../../../lib/paths/antrag_FULL_Paths.json';
import { FormStrucItem } from '../../../../../../../../../lib/types/types';
import { ForceTrue } from '../../../../../../../../../lib/validation/ValidationTypes';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';
const P = Schema.attributes;

const NachweisEffektivitaetEffizienzAntragKreativwirtschaft: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Nachweis der Effektivität und Effizienz der Maßnahme' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm
				formStruc={formStrucFunktion()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default NachweisEffektivitaetEffizienzAntragKreativwirtschaft;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStrucFunktion = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0160712500_iv_Gemessen_Und_Dokumentiert,
				P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Projektbeschreibung_Krea_0160502836_iert_Und_Ggf_Weiterverwendet,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucNachweisEffektivitaetEffizienzAntragKreativwirtschaft = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Pruefstatus.path,
			P.Projektbeschreibung_Kreativwirtschaft.schema.attributes.Pruefung_Effizienz_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStrucFunktion());
	return concat(formStrucFunktion());
};
